<template>
	<div class="product-variation-price">
		<span class="has-text-success">{{
			/* "$" + currentVariationPrice + " JMD" */
		}}</span>
	</div>
</template>
<style lang="scss" scoped></style>
<script type="text/javascript">
	import Vue from "vue";
	export default {
		props: [],
		data() {
			return {
				state: this.$store.state,
				productVariationPrice: 0,
			};
		},
		mounted() {},
		computed: {
			currentVariationPrice() {
				return this.productVariationPrice;
			},
			getterVariationPrice() {
				return this.$store.getters.productVariationPrice;
			},
		},
		methods: {},
		watch: {
			state: {
				deep: true,
				handler(newValue, oldValue) {
					console.debug("ProductVariationPrice: State Check in");
					this.products = this.$store.getters.products;
					this.productVariationPrice =
						this.$store.getters.productVariationPrice;
				},
			},
		},
	};
</script>
